import * as React from "react";
const SvgOwner = (props) => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M12 9.75L14.25 12M14.25 12L12 14.25M14.25 12H3.75M6 8.25L3.75 6M3.75 6L6 3.75M3.75 6H14.25", stroke: "#1A1A1A", style: {
  stroke: "#1A1A1A",
  stroke: "color(display-p3 0.1020 0.1020 0.1020)",
  strokeOpacity: 1
}, strokeWidth: 1.41, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgOwner;
